export const INDIVIDUAL_SIGNUP_OWNER_ID =
  "2301ab0e-a588-40b5-8e77-3e0b31de865c";

export const INDIVIDUAL_SIGNUP_VIEWER_IDS = [
  INDIVIDUAL_SIGNUP_OWNER_ID,
  "079ae1a9-b9f1-4939-89c9-63c74f30dd47",
];

export const BUSINESS_SIGNUP_OWNER_ID =
  "1daa441a-99b6-4752-b9e7-f189b6f8dc17";

export const BUSINESS_SIGNUP_VIEWER_IDS = [BUSINESS_SIGNUP_OWNER_ID];

export const SIGNUP_ROUTING_EMPLOYEE_IDS = [
  ...INDIVIDUAL_SIGNUP_VIEWER_IDS,
  ...BUSINESS_SIGNUP_VIEWER_IDS,
];

const normalizeClientType = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const getSignupRouting = (clientType) => {
  if (normalizeClientType(clientType) === "business") {
    return {
      ownerId: BUSINESS_SIGNUP_OWNER_ID,
      viewerIds: BUSINESS_SIGNUP_VIEWER_IDS,
    };
  }

  return {
    ownerId: INDIVIDUAL_SIGNUP_OWNER_ID,
    viewerIds: INDIVIDUAL_SIGNUP_VIEWER_IDS,
  };
};

export const buildSignupEmployeeAssignment = ({
  clientType,
  consultantId,
}) => {
  const { ownerId, viewerIds } = getSignupRouting(clientType);
  const primaryEmployeeId = consultantId || ownerId;

  return {
    employee_id: primaryEmployeeId,
    assigned_employee_ids: Array.from(
      new Set([primaryEmployeeId, ...viewerIds].filter(Boolean)),
    ),
  };
};

export const canManageSignupClients = (employeeId) =>
  SIGNUP_ROUTING_EMPLOYEE_IDS.includes(String(employeeId || ""));

export const getSignupClientTypeForEmployee = (employeeId) => {
  const id = String(employeeId || "");
  if (INDIVIDUAL_SIGNUP_VIEWER_IDS.includes(id)) return "Individual";
  if (BUSINESS_SIGNUP_VIEWER_IDS.includes(id)) return "Business";
  return null;
};
